import { useEffect, useRef, useState } from 'preact/hooks'
import Icon from 'snippets/icon/icon'

/**
 * Inline "+ New Wishlist" form. Promoted to the primary action when the shopper
 * has no lists at all.
 */
export const WishlistCreateRow = ({ isPrimary, isSaving, error, onCreate }) => {
  const [isEditing, setIsEditing] = useState(false)
  const [name, setName] = useState('')
  const inputRef = useRef(null)

  useEffect(() => {
    if (isEditing) inputRef.current?.focus()
  }, [isEditing])

  const cancel = () => {
    setIsEditing(false)
    setName('')
  }

  const confirm = async () => {
    const trimmed = name.trim()
    if (!trimmed) return
    const created = await onCreate(trimmed)
    if (created) cancel()
  }

  if (!isEditing) {
    return (
      <button
        type="button"
        disabled={isSaving}
        onClick={() => setIsEditing(true)}
        data-role="wishlist-drawer-create-open"
        class={`btn btn-md w-full ${isPrimary ? 'btn-solid-black' : 'btn-outline-black'}`}
      >
        + New Wishlist
      </button>
    )
  }

  return (
    <div class="flex flex-col gap-2 rounded border border-neutrals-medium-grey p-3">
      <div class="flex flex-row items-center gap-2">
        <input
          ref={inputRef}
          value={name}
          disabled={isSaving}
          placeholder="Name your list"
          data-role="wishlist-drawer-create-input"
          onInput={(event) => setName(event.currentTarget.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') confirm()
            if (event.key === 'Escape') cancel()
          }}
          class="min-w-0 flex-1 border border-neutrals-medium-grey p-2 paragraph-sm"
        />
        <button
          type="button"
          disabled={isSaving}
          onClick={cancel}
          aria-label="Cancel"
          data-role="wishlist-drawer-create-cancel"
        >
          <Icon id="close" className="w-5 h-5 text-primary-black" />
        </button>
        <button
          type="button"
          disabled={isSaving || !name.trim()}
          onClick={confirm}
          aria-label="Create list"
          data-role="wishlist-drawer-create-confirm"
        >
          <Icon id="tick" className="w-5 h-5 text-primary-black" />
        </button>
      </div>

      {error && (
        <div data-role="wishlist-drawer-create-error" class="text-system-error paragraph-xs">
          {error}
        </div>
      )}
    </div>
  )
}
